module.exports = __webpack_public_path__ + "img/tl.241ac306.svg";